import React, { useContext, useEffect, useCallback } from "react";
// import Box from "@mui/material/Box";
// import Fab from "@mui/material/Fab";
import instance from "../api/api";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AddShoppingCart from "@mui/icons-material/AddShoppingCart";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Button, CardActionArea, CardActions, Grid } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import { makeStyles } from "@mui/styles";
// import { createMuiTheme } from '@mui/styles';
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import AspectRatio from "@mui/joy/AspectRatio";
import { Context } from "../context/ContextProvider";
import { ApplePayButton } from "react-apple-pay-button";
// import SimpleButton from "../helpers/SimpleButton";
// import applePay from "../helpers/applePay";
import SelectedShoppingCart from "./ApplePay/SelectShoppingCart";
import * as cartData from "./ApplePay/cart-data";

const applePayButtonStyles = {
  backgroundImage: "-webkit-named-image(apple-pay-logo-white)",
  backgroundColor: "black",
  backgroundSize: "100% 60%",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  border: "1px solid transparent",
  borderRadius: "4px",
  minHeight: "50px",
  minWidth: "150px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    backgroundColor: theme.palette.common.red,
  },
  table: {
    minWidth: 300,
  },
  applePayButton: {
    "--apple-pay-button-width": "200px",
    "--apple-pay-button-height": "30px",
    "--apple-pay-button-border-radius": "3px",
    "--apple-pay-button-padding": "0px 0px",
    "--apple-pay-button-box-sizing": "border-box",
    // "backgroundImage": "-webkit-named-image(apple-pay-logo-white)",
    // "backgroundColor": "white",
  },
}));

const OrdersList = ({ t, i18n }) => {
  //   const {} = useContext(Context);

  // var request = {
  //   countryCode: "SA",
  //   currencyCode: "SAR",
  //   supportedNetworks: ["visa", "masterCard","mada"],
  //   merchantCapabilities: ["supports3DS"],
  //   total: { label: "Your Merchant Name", amount: "10.00" },
  // };

  //   useEffect(() => {
  //     const PaymentApplePay = () => {
  //       if (window.ApplePaySession) {
  //         console.log("here: 11");
  //         var merchantIdentifier = "merchant.com.adeb1991.explicationyourdream";
  //         var promise =
  //           window.ApplePaySession.canMakePaymentsWithActiveCard(
  //             merchantIdentifier
  //           );
  //         promise.then(function (canMakePayments) {
  //           if (canMakePayments) {
  //             // Display Apple Pay button here.
  //             //   console.log("jjdf", canMakePayments);
  //             const data = window.ApplePaySession(3, request);
  //             console.log("here: 22 ");
  //             console.log("data", data);
  //           }
  //         });
  //       }
  //     };
  //     PaymentApplePay();
  //   }, []);

  //   const PaymentApplePay = () => {
  //     if (window.ApplePaySession) {
  //       console.log("here: 11");
  //       var merchantIdentifier = "merchant.com.adeb1991.explicationyourdream";
  //       var promise = ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
  //       promise.then(function (canMakePayments) {
  //         if (canMakePayments) {
  //           // Display Apple Pay button here.
  //           //   console.log("jjdf", canMakePayments);
  //           //   const data = new ApplePaySession(3, request);
  //           console.log("here: 22 ");
  //           //   console.log("data", data);
  //           var session = new ApplePaySession(1, request);

  //           session.onvalidatemerchant = function (event) {
  //             console.log("validate merchant called");

  //             // api service call with event.validationUrl to get the session data
  //           };

  //           session.onPaymentAuthorized = function (event) {
  //             console.log("on payment authorized called");

  //             // get payment token and call api service with details for
  //             // payment processing
  //           };

  //           console.log("begin Apple Pay session");
  //           session.begin();
  //         }
  //       });
  //     }
  //   };
  //   const onRequestApplePay = useCallback(() => PaymentApplePay(), []);

  // const classes = useStyles();
  return (
    <div>
      <div style={{ margin: 20, marginTop: 150 }}>
        {/* <p>apple pay</p> */}
        {/* <style>

        </style> */}
        {/* <apple-pay-button
          className={classes.applePayButton}
          buttonstyle="black"
          type="plain"
          locale="en"
        ></apple-pay-button> */}
        {/* <button className={classes.applePayButton} onClick={PaymentApplePay}>
          pay apple
        </button> */}
        {/* <SimpleButton style={classes.applePayButton} onClick={applePay.startApplePay}/> */}

        {/* <SelectedShoppingCart {...cartData}/> */}
      </div>
    </div>
  );
};

export default OrdersList;
